export default __webpack_public_path__ + "static/200511_KMW_by_Kruszewski_0732-35ee3a740706c47a9b1b499086acdbe0.jpg";